import { render, staticRenderFns } from "./CompetitiveProcessesCard.vue?vue&type=template&id=bb35e622"
import script from "./CompetitiveProcessesCard.vue?vue&type=script&lang=js"
export * from "./CompetitiveProcessesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports